import React from 'react';
import { FormType } from '../../../types/types';
import {
  Text,
  TextButton,
  TextButtonPriority,
  TextPriority,
} from 'wix-ui-tpa/cssVars';
import { classes } from './FormSwitchBarSection.st.css';
import { useFormSwitchBarSectionSettings } from './useFormSwitchBarSectionSettings';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { TEXT_DIRECTION } from '../../../constants';

interface FormSwitchBarSectionProps {
  formType: FormType;
  onSwitchForm: () => void;
}

export const FormSwitchBarSection = ({
  formType,
  onSwitchForm,
}: FormSwitchBarSectionProps) => {
  const { shouldShowFormSwitchBar, prefixText, textButtonText } =
    useFormSwitchBarSectionSettings({ formType });
  const { isRTL } = useEnvironment();

  if (!shouldShowFormSwitchBar || !prefixText || !textButtonText) {
    return null;
  }

  const textElement = (
    <Text
      priority={TextPriority.secondary}
      data-hook={`${formType}-form-switch-bar-prefix`}
      className={classes.formSwitchBarPrefix}
    >
      {prefixText}
    </Text>
  );

  const linkElement = (
    <TextButton
      className={classes.formSwitchBarLink}
      priority={TextButtonPriority.primary}
      href="#"
      // Prevent focus change on pointer down so the input doesn't blur before this action
      onPointerDown={(e) => e.preventDefault()}
      onClick={onSwitchForm}
      data-hook={`${formType}-form-switch-bar-link`}
    >
      {textButtonText}
    </TextButton>
  );

  return (
    <div className={classes.formSwitchBar}>
      <div
        className={classes.formSwitchBarText}
        dir={isRTL ? TEXT_DIRECTION.RTL : TEXT_DIRECTION.LTR}
      >
        {textElement}
        {linkElement}
      </div>
    </div>
  );
};
